import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useB2BProgramSubscription = (programId: string) => {
  const { boxB2BProgramApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: subscribeToBoxB2BProgram, isPending: isSubscribing } = useMutation({
    mutationFn: async () => {
      const result = await boxB2BProgramApi.subscribeToBoxB2BProgram(programId)
      return result.status
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["boxB2BPrograms"] })
      await queryClient.invalidateQueries({ queryKey: ["program", programId] })
    },
  })

  return {
    subscribeToBoxB2BProgram,
    isSubscribing,
  }
}

export const useB2BProgramUnsubscription = (programId: string) => {
  const { boxB2BProgramApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: unsubscribeToBoxB2BProgram, isPending: isUnsubscribing } = useMutation({
    mutationFn: async () => {
      const result = await boxB2BProgramApi.unsubscribeToBoxB2BProgram(programId)
      return result.status
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["boxB2BPrograms"] })
      await queryClient.invalidateQueries({ queryKey: ["program", programId] })
    },
  })

  return {
    unsubscribeToBoxB2BProgram,
    isUnsubscribing,
  }
}
